<template>
  <v-card>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon v-if="newDocNoForm">mdi-plus</v-icon>
      <v-icon v-else>mdi-magnify</v-icon>
      <v-toolbar-title>{{ header }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text style="height: 600px">
      <message :messages="messages"></message>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6 v-if="newDocNoForm">
            <v-autocomplete
              :items="docTypeList"
              v-model="docNoFormForm.docType"
              :label="labels.docType"
              item-text="label"
              item-value="value"
              data-vv-name="docType"
              :data-vv-as="labels.docType"
              :error-messages="errors.collect('docType')"
              v-validate="'required'"
            />
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.docType }}</v-subheader>
            <div class="queryValue">{{ getDesc('docType', docNoFormForm.docType) }}</div>
          </v-flex>
          <v-flex xs6 v-if="newDocNoForm">
            <v-autocomplete
              :items="formIdList"
              v-model="docNoFormForm.formId"
              :label="labels.formId"
              item-text="label"
              item-value="value"
              data-vv-name="formId"
              :data-vv-as="labels.formId"
              :error-messages="errors.collect('formId')"
              v-validate="'required'"
              :disabled="disc"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.formId }}</v-subheader>
            <div class="queryValue">{{ getDesc('formId', docNoFormForm.formId) }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="newDocNoForm">
            <v-text-field
              v-model="docNoFormForm.formDesc"
              :label="labels.formDesc"
              item-text="label"
              item-value="value"
              data-vv-name="formDesc"
              :data-vv-as="labels.formDesc"
              :error-messages="errors.collect('formDesc')"
              v-validate="'required|max:30'"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.formDesc }}</v-subheader>
            <div class="queryValue">{{ docNoFormForm.formDesc }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="newDocNoForm">
            <cal-picker
              :label="labels.effDate"
              v-model="docNoFormForm.effDate"
              :error-messages="errors.collect('effDate')"
              data-vv-name="effDate"
              :data-vv-as="labels.effDate"
              v-validate="'required'"
            ></cal-picker>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.effDate }}</v-subheader>
            <div class="queryValue">{{ formatDisplayDate(docNoFormForm.effDate) }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="newDocNoForm">
            <v-autocomplete
              :items="keyFactList"
              v-model="docNoFormForm.keyFact1Type"
              :label="labels.keyFact1Type"
              item-text="label"
              item-value="value"
              data-vv-name="keyFact1Type"
              :data-vv-as="labels.keyFact1Type"
              :error-messages="errors.collect('keyFact1Type')"
              v-validate="'required' + checkDup(1, docNoFormForm.keyFact1Type)"
              @change="getExpectedLengthLayout(docNoFormForm)"
              :disabled="disc"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.keyFact1Type }}</v-subheader>
            <div class="queryValue">{{ getDesc('keyFact', docNoFormForm.keyFact1Type) }}</div>
          </v-flex>
          <v-flex xs6 v-if="newDocNoForm">
            <v-checkbox
              v-model="docNoFormForm.inclFact1seqNo"
              :label="labels.inclFact1seqNo"
              :error-messages="errors.collect('inclFact1seqNo')"
              data-vv-name="inclFact1seqNo"
              :data-vv-as="labels.inclFact1seqNo"
              hide-details
              :disabled="
                disc ||
                docNoFormForm.keyFact1Type === '751' ||
                docNoFormForm.keyFact1Type === '151' ||
                docNoFormForm.keyFact1Type === '752' ||
                docNoFormForm.keyFact1Type === '781' ||
                docNoFormForm.keyFact1Type === '782' ||
                docNoFormForm.keyFact1Type === '783'
              "
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.inclFact1seqNo }}</v-subheader>
            <div class="queryValue">{{ formatBoolean(docNoFormForm.inclFact1seqNo) }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="newDocNoForm">
            <v-autocomplete
              :items="keyFactList"
              v-model="docNoFormForm.keyFact2Type"
              :label="labels.keyFact2Type"
              item-text="label"
              item-value="value"
              data-vv-name="keyFact2Type"
              :data-vv-as="labels.keyFact2Type"
              :error-messages="errors.collect('keyFact2Type')"
              @change="getExpectedLengthLayout(docNoFormForm)"
              v-validate="'required' + checkDup(2, docNoFormForm.keyFact2Type)"
              :disabled="disc"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.keyFact2Type }}</v-subheader>
            <div class="queryValue">{{ getDesc('keyFact', docNoFormForm.keyFact2Type) }}</div>
          </v-flex>
          <v-flex xs6 v-if="newDocNoForm">
            <v-checkbox
              v-model="docNoFormForm.inclFact2seqNo"
              :label="labels.inclFact2seqNo"
              :error-messages="errors.collect('inclFact2seqNo')"
              data-vv-name="inclFact2seqNo"
              :data-vv-as="labels.inclFact2seqNo"
              hide-details
              :disabled="
                disc ||
                docNoFormForm.keyFact2Type === '751' ||
                docNoFormForm.keyFact2Type === '151' ||
                docNoFormForm.keyFact2Type === '752' ||
                docNoFormForm.keyFact2Type === '781' ||
                docNoFormForm.keyFact2Type === '782' ||
                docNoFormForm.keyFact2Type === '783'
              "
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.inclFact2seqNo }}</v-subheader>
            <div class="queryValue">{{ formatBoolean(docNoFormForm.inclFact2seqNo) }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="newDocNoForm">
            <v-autocomplete
              :items="keyFactList"
              v-model="docNoFormForm.keyFact3Type"
              :label="labels.keyFact3Type"
              item-text="label"
              item-value="value"
              data-vv-name="keyFact3Type"
              :data-vv-as="labels.keyFact3Type"
              :error-messages="errors.collect('keyFact3Type')"
              v-validate="'required' + checkDup(3, docNoFormForm.keyFact3Type)"
              @change="getExpectedLengthLayout(docNoFormForm)"
              :disabled="disc"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.keyFact3Type }}</v-subheader>
            <div class="queryValue">{{ getDesc('keyFact', docNoFormForm.keyFact3Type) }}</div>
          </v-flex>
          <v-flex xs6 v-if="newDocNoForm">
            <v-checkbox
              v-model="docNoFormForm.inclFact3seqNo"
              :label="labels.inclFact3seqNo"
              :error-messages="errors.collect('inclFact3seqNo')"
              data-vv-name="inclFact3seqNo"
              :data-vv-as="labels.inclFact3seqNo"
              hide-details
              :disabled="
                disc ||
                docNoFormForm.keyFact3Type === '751' ||
                docNoFormForm.keyFact3Type === '151' ||
                docNoFormForm.keyFact3Type === '752' ||
                docNoFormForm.keyFact3Type === '781' ||
                docNoFormForm.keyFact3Type === '782' ||
                docNoFormForm.keyFact3Type === '783'
              "
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.inclFact3seqNo }}</v-subheader>
            <div class="queryValue">{{ formatBoolean(docNoFormForm.inclFact3seqNo) }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="newDocNoForm">
            <v-autocomplete
              :items="keyFactList"
              v-model="docNoFormForm.keyFact4Type"
              :label="labels.keyFact4Type"
              item-text="label"
              item-value="value"
              data-vv-name="keyFact4Type"
              :data-vv-as="labels.keyFact4Type"
              :error-messages="errors.collect('keyFact4Type')"
              v-validate="'required' + checkDup(4, docNoFormForm.keyFact4Type)"
              @change="getExpectedLengthLayout(docNoFormForm)"
              :disabled="disc"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.keyFact4Type }}</v-subheader>
            <div class="queryValue">{{ getDesc('keyFact', docNoFormForm.keyFact4Type) }}</div>
          </v-flex>
          <v-flex xs6 v-if="newDocNoForm">
            <v-checkbox
              v-model="docNoFormForm.inclFact4seqNo"
              :label="labels.inclFact4seqNo"
              :error-messages="errors.collect('inclFact4seqNo')"
              data-vv-name="inclFact4seqNo"
              :data-vv-as="labels.inclFact4seqNo"
              hide-details
              :disabled="
                disc ||
                docNoFormForm.keyFact4Type === '751' ||
                docNoFormForm.keyFact4Type === '151' ||
                docNoFormForm.keyFact4Type === '752' ||
                docNoFormForm.keyFact4Type === '781' ||
                docNoFormForm.keyFact4Type === '782' ||
                docNoFormForm.keyFact4Type === '783'
              "
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.inclFact4seqNo }}</v-subheader>
            <div class="queryValue">{{ formatBoolean(docNoFormForm.inclFact4seqNo) }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="newDocNoForm">
            <v-autocomplete
              :items="keyFactList"
              v-model="docNoFormForm.keyFact5Type"
              :label="labels.keyFact5Type"
              item-text="label"
              item-value="value"
              data-vv-name="keyFact5Type"
              :data-vv-as="labels.keyFact5Type"
              :error-messages="errors.collect('keyFact5Type')"
              v-validate="'required' + checkDup(5, docNoFormForm.keyFact5Type)"
              @change="getExpectedLengthLayout(docNoFormForm)"
              :disabled="disc"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.keyFact5Type }}</v-subheader>
            <div class="queryValue">{{ getDesc('keyFact', docNoFormForm.keyFact5Type) }}</div>
          </v-flex>
          <v-flex xs6 v-if="newDocNoForm">
            <v-checkbox
              v-model="docNoFormForm.inclFact5seqNo"
              :label="labels.inclFact5seqNo"
              :error-messages="errors.collect('inclFact5seqNo')"
              data-vv-name="inclFact5seqNo"
              :data-vv-as="labels.inclFact5seqNo"
              hide-details
              :disabled="
                disc ||
                docNoFormForm.keyFact5Type === '751' ||
                docNoFormForm.keyFact5Type === '151' ||
                docNoFormForm.keyFact5Type === '752' ||
                docNoFormForm.keyFact5Type === '781' ||
                docNoFormForm.keyFact5Type === '782' ||
                docNoFormForm.keyFact5Type === '783'
              "
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.inclFact5seqNo }}</v-subheader>
            <div class="queryValue">{{ formatBoolean(docNoFormForm.inclFact5seqNo) }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 v-if="newDocNoForm">
            <v-autocomplete
              :items="keyFactList"
              v-model="docNoFormForm.keyFact6Type"
              :label="labels.keyFact6Type"
              item-text="label"
              item-value="value"
              data-vv-name="keyFact6Type"
              :data-vv-as="labels.keyFact6Type"
              :error-messages="errors.collect('keyFact6Type')"
              v-validate="'required' + checkDup(6, docNoFormForm.keyFact6Type)"
              @change="getExpectedLengthLayout(docNoFormForm)"
              :disabled="disc"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.keyFact6Type }}</v-subheader>
            <div class="queryValue">{{ getDesc('keyFact', docNoFormForm.keyFact6Type) }}</div>
          </v-flex>
          <v-flex xs6 v-if="newDocNoForm">
            <v-checkbox
              v-model="docNoFormForm.inclFact6seqNo"
              :label="labels.inclFact6seqNo"
              :error-messages="errors.collect('inclFact6seqNo')"
              data-vv-name="inclFact6seqNo"
              :data-vv-as="labels.inclFact6seqNo"
              hide-details
              :disabled="
                disc ||
                docNoFormForm.keyFact6Type === '751' ||
                docNoFormForm.keyFact6Type === '151' ||
                docNoFormForm.keyFact6Type === '752' ||
                docNoFormForm.keyFact6Type === '781' ||
                docNoFormForm.keyFact6Type === '782' ||
                docNoFormForm.keyFact6Type === '783'
              "
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.inclFact6seqNo }}</v-subheader>
            <div class="queryValue">{{ formatBoolean(docNoFormForm.inclFact6seqNo) }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.totalLength }}</v-subheader>
            <div class="queryValue">{{ layoutForm.totalLength }}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.expLayout }}</v-subheader>
            <div class="queryValue">{{ layoutForm.expLayout }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
            <div class="queryValue">{{ docNoFormForm.createdName }}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
            <div class="queryValue">{{ formatDisplayDate(docNoFormForm.createdDate) }}</div>
          </v-flex>
          <v-flex xs6 v-if="!newDocNoForm">
            <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
            <div class="queryValue">{{ docNoFormForm.modifiedName }}</div>
          </v-flex>
          <v-flex xs6 v-if="!newDocNoForm">
            <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
            <div class="queryValue">{{ formatDisplayDate(docNoFormForm.modifiedDate) }}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click.native="close">Cancel</v-btn>
      <v-btn v-if="newDocNoForm" color="primary" text @click.native="doSave">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { docNoFormMixin } from './docNoFormMixin'

export default {
  props: {
    docNoFormForm: Object,
    newDocNoForm: Boolean,
    visible: Boolean,
    viewLayoutForm: Object
  },
  data() {
    return {
      labels: {
        docType: 'Document Type',
        formId: 'Format ID',
        formDesc: 'Document Description',
        effDate: 'Effective Date',
        keyFact1Type: 'Key Factor 1 Type',
        keyFact2Type: 'Key Factor 2 Type',
        keyFact3Type: 'Key Factor 3 Type',
        keyFact4Type: 'Key Factor 4 Type',
        keyFact5Type: 'Key Factor 5 Type',
        keyFact6Type: 'Key Factor 6 Type',
        inclFact1seqNo: 'Sequence No. by Key Factor 1 Type',
        inclFact2seqNo: 'Sequence No. by Key Factor 2 Type',
        inclFact3seqNo: 'Sequence No. by Key Factor 3 Type',
        inclFact4seqNo: 'Sequence No. by Key Factor 4 Type',
        inclFact5seqNo: 'Sequence No. by Key Factor 5 Type',
        inclFact6seqNo: 'Sequence No. by Key Factor 6 Type',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        totalLength: 'Document No. Length',
        expLayout: 'Example Layout'
      },
      today: new Date(),
      // cDocument
      branch1C: '',
      branch2C: '',
      polType1C: '',
      polType2C: '',
      polType3C: '',
      year2C: null,
      year4C: null,
      dept1C: '',
      busSrc1C: '',
      disc: false,
      layoutForm: {
        totalLength: 0,
        expLayout: ''
      },
      maxLength: 0,
      keyFactList: [],
      header: '',
      loading: false,
      submitting: false,
      month2C: null
    }
  },
  watch: {
    visible: function (value) {
      if (value) {
        this.doInit()
      }
    },
    'docNoFormForm.docType': function (value) {
      if (value === 'P') {
        this.maxLength = 16
      } else if (value === 'C') {
        this.maxLength = 12
      } else {
        this.maxLength = 0
      }
      this.getKeyFactList(this.docNoFormForm)

      this.$nextTick(() => {
        if (this.viewLayoutForm.expLayout === '' && this.viewLayoutForm.totalLength === 0) {
          this.getExpectedLengthLayout(this.docNoFormForm)
        }
      })
    },
    'layoutForm.totalLength': function (value) {
      this.$validator.validateAll('layoutForm')
    }
  },
  computed: {
    menu() {
      return this.$store.state.docFormatParam.menu
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.year2C = parseInt(this.today.getFullYear()) - 2000
      this.year4C = this.today.getFullYear()
      this.month2C = ('' + this.today.getMonth()).padStart(2, '0')
      if (this.newDocNoForm) {
        this.header = 'Create New Doc No. Format'
        this.doInitForm()
      } else {
        this.header = 'View Doc No. Format'
        this.getKeyFactList(this.docNoFormForm)
        if (this.viewLayoutForm.expLayout === '' && this.viewLayoutForm.totalLength === 0) {
          this.getExpectedLengthLayout(this.docNoFormForm)
        } else {
          this.layoutForm.expLayout = this.viewLayoutForm.expLayout
          this.layoutForm.totalLength = this.viewLayoutForm.totalLength
        }
      }
    },
    doInitForm() {
      this.resetValidator()
      this.resetMessages()
      this.docNoFormForm.docType = null
      this.docNoFormForm.formId = null
      this.docNoFormForm.docDesc = null
      this.docNoFormForm.effDate = this.today
      this.docNoFormForm.keyFact1Type = ''
      this.docNoFormForm.keyFact2Type = ''
      this.docNoFormForm.keyFact3Type = ''
      this.docNoFormForm.keyFact4Type = ''
      this.docNoFormForm.keyFact5Type = ''
      this.docNoFormForm.keyFact6Type = ''
      this.docNoFormForm.inclFact1seqNo = false
      this.docNoFormForm.inclFact2seqNo = false
      this.docNoFormForm.inclFact3seqNo = false
      this.docNoFormForm.inclFact4seqNo = false
      this.docNoFormForm.inclFact5seqNo = false
      this.docNoFormForm.inclFact6seqNo = false
      this.docNoFormForm.createdName = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.docNoFormForm.createdDate = new Date()
      this.layoutForm.totalLength = 0
      this.layoutForm.expLayout = ''
    },
    formatDisplayDate(xDate) {
      if (xDate) {
        return formatDisplayDate(xDate)
      } else {
        return undefined
      }
    },
    formatBoolean(bool) {
      if (bool) {
        return 'Yes'
      } else {
        return 'No'
      }
    },
    getDesc(field, id) {
      var list = []
      if (field === 'docType') {
        list = this.docTypeList
      } else if (field === 'formId') {
        list = this.formIdList
      } else {
        list = this.keyFactList
      }
      if (id) {
        for (var i in list) {
          if (id === list[i].value) {
            return list[i].label
          }
        }
      }
    },
    checkDup(no, keyFact) {
      var dup = '|keyFactVal:' + false
      var notDup = ''
      if (keyFact) {
        if (keyFact === 'NA') {
          return notDup
        } else {
          if (no === 1) {
            return notDup
          } else if (no === 2) {
            if (keyFact === this.docNoFormForm.keyFact1Type) {
              return dup
            } else {
              return notDup
            }
          } else if (no === 3) {
            if (keyFact === this.docNoFormForm.keyFact1Type) {
              return dup
            } else if (keyFact === this.docNoFormForm.keyFact2Type) {
              return dup
            } else {
              return notDup
            }
          } else if (no === 4) {
            if (keyFact === this.docNoFormForm.keyFact1Type) {
              return dup
            } else if (keyFact === this.docNoFormForm.keyFact2Type) {
              return dup
            } else if (keyFact === this.docNoFormForm.keyFact3Type) {
              return dup
            } else {
              return notDup
            }
          } else if (no === 5) {
            if (keyFact === this.docNoFormForm.keyFact1Type) {
              return dup
            } else if (keyFact === this.docNoFormForm.keyFact2Type) {
              return dup
            } else if (keyFact === this.docNoFormForm.keyFact3Type) {
              return dup
            } else if (keyFact === this.docNoFormForm.keyFact4Type) {
              return dup
            } else {
              return notDup
            }
          } else if (no === 6) {
            if (keyFact === this.docNoFormForm.keyFact1Type) {
              return dup
            } else if (keyFact === this.docNoFormForm.keyFact2Type) {
              return dup
            } else if (keyFact === this.docNoFormForm.keyFact3Type) {
              return dup
            } else if (keyFact === this.docNoFormForm.keyFact4Type) {
              return dup
            } else if (keyFact === this.docNoFormForm.keyFact5Type) {
              return dup
            } else {
              return notDup
            }
          } else {
            return notDup
          }
          /*
          // CBO: Temporary removed these lines to fix the issue reported on 22/10/2019
          if (no !== 1) {
            // for 2~6
            // console.log(no)
            if (keyFact === this.docNoFormForm.keyFact1Type) {
              // if 2~6 keyfact = keyfact 1 then return msg
              // console.log('bbb')
              return dup
            }
          }
          if (no !== 2) { if (keyFact === this.docNoFormForm.keyFact2Type) { return dup } }
          if (no !== 3) { if (keyFact === this.docNoFormForm.keyFact3Type) { return dup } }
          if (no !== 4) { if (keyFact === this.docNoFormForm.keyFact4Type) { return dup } }
          if (no !== 5) { if (keyFact === this.docNoFormForm.keyFact5Type) { return dup } }
          if (no !== 6) { if (keyFact === this.docNoFormForm.keyFact6Type) { return dup } }
          return notDup
          */
        }
      } else {
        return notDup
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.layoutForm.totalLength > this.maxLength) {
            // CBO : 2019/10/24, Not sure why this field is being skipped during validateAll()
            // although the error msg is displayed.
            // Added a condition to do promptFieldCheck()
            this.promptFieldCheck()
          } else {
            if (this.newDocNoForm) {
              this.doCreate()
            } else {
              this.doUpdate()
            }
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createDocNoForm
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.docNoFormForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.close()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateDocNoForm
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.docNoFormForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.close()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    close() {
      this.doInitForm()
      this.$emit('close')
    }
  },
  created() {
    this.getTop1Value()
    this.doInit()
    const keyFactVal = {
      getMessage: (field, args) => {
        return 'You have selected this Key Factor Type'
      },
      validate: (value, args) => {
        return !args[0]
      }
    }
    this.$validator.extend('keyFactVal', keyFactVal)
  },
  mixins: [MessageMixin, docNoFormMixin]
}
</script>
